// extracted by mini-css-extract-plugin
export default {"header":"version_header__ZMb7P","text":"version_text__wwurl","btn":"version_btn__23pVv","img":"version_img__gVDuD"};